import InputBlock from './InputBlock';

export default InputBlock;



// WEBPACK FOOTER //
// ./scripts/blocks/form/components/InputBlock/index.js